function requireEnv<K extends keyof ImportMetaEnv>(key: K): ImportMetaEnv[K] {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

function optionalEnv<K extends keyof ImportMetaEnv>(
  key: K,
  fallback: ImportMetaEnv[K],
): ImportMetaEnv[K] {
  return import.meta.env[key] ?? fallback;
}

export const config = {
  apiBaseUrl: `${requireEnv("VITE_HTTPS_PROTOCOL")}${requireEnv("VITE_BASE_URL")}`,
  wssBaseUrl: `${requireEnv("VITE_WSS_PROTOCOL")}${requireEnv("VITE_WEBSOCKETS_BASE")}`,
  buildVersion: optionalEnv("VITE_BUILD_VERSION", "local"),
  launchDarklyClientId: requireEnv("VITE_LAUNCH_DARKLY_CLIENT_ID"),
  apimKey: requireEnv("VITE_APIM_KEY"),
  apiKey: requireEnv("VITE_API_KEY"),
  apiKeyLocker: optionalEnv("VITE_API_KEY_LOCKER", ""),
  rexSrcPath: requireEnv("VITE_SRC_PATH"),
  pwReset: requireEnv("VITE_PW_RESET"),
  isRexDevelopment: requireEnv("VITE_REX_DEVELOPMENT"),
  enableDevTools: requireEnv("VITE_ENABLE_DEVTOOLS"),
  azureSas: requireEnv("VITE_AZURE_SAS"),

  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  mode: import.meta.env.MODE,
} as const;

export type Config = typeof config;

// Validate on import - app won't start if env vars are missing
function validateConfig(): void {
  // Just accessing config triggers all the requireEnv calls
  void config.apiBaseUrl;
  void config.launchDarklyClientId;
}

validateConfig();
